import React, { Component } from "react";
import "./style.css";
class MajorBrow extends Component {
  render() {
    const { majorTypeCode, majorType } = this.props;
    return (
      <div className="majorbrow_box">
        <div className="majorbrow_box_left fl">{majorTypeCode}</div>
        <div className="majorbrow_box_right fl">{majorType}</div>
      </div>
    );
  }
}

export default MajorBrow;



// WEBPACK FOOTER //
// ./src/containers/Major/components/MajorBrow/index.js